import { Component, Input, ViewEncapsulation } from '@angular/core';
import { DatabaseType } from '../../../../_study_constants';

@Component({
  selector: 'app-drill-down-financial-category',
  templateUrl: './financial-category.component.html',
  styleUrls: ['./financial-category.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class FinancialCategoryComponent {
  @Input() items: any[];
  @Input() headerRows: { cols: any }[];
  @Input() tabName: string;
  @Input() databaseId: number;

  noParent(data): boolean {
    return data['parentId'] === -1;
  }

  isChild(data): boolean {
    return data['parentId'] > 0;
  }

  isNum(data) {
    const trimmed = data.trim();
    return trimmed !== '' && !isNaN(+trimmed);
  }

  get isNonBvd(): boolean {
    return (
      this.databaseId === DatabaseType.CompustatGlobal || this.databaseId === DatabaseType.CompustatNA || this.databaseId === DatabaseType.OneSource
    );
  }
}
